import { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { useLanguage } from "../context/LanguageProvider";
import { hasRouteAccess } from "./permissions"; 
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import { Toaster } from 'sonner';
import { appConfig } from "../apiConfig";
import Cookies from "js-cookie";


export default function DashboardLayout() {
  const { t } = useLanguage();
  const { user, checkAuth, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const init = async () => {
      const token = Cookies.get("WEB_STT");
      if (!token) {
        navigate("/login", { replace: true });
        return;
      }
      await checkAuth();
    };
    init();
  }, []);

  useEffect(() => {
    checkAuth();
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setSidebarOpen(!mobile);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate("/login", { replace: true });
        return;
      }

      if (!hasRouteAccess(location.pathname, user)) {
        navigate("/dashboard", { replace: true });
      }

      document.title = `${appConfig.name} | ${t('layout.dashboard.page_title')}`;
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.href = `/images/${appConfig.slug}-fav.png`;
      }
    }
  }, [location.pathname, user, loading, navigate]);

  return (
    <div className="min-h-screen bg-white">
      
      <div className="flex">
        <Navbar open={sidebarOpen} setOpen={setSidebarOpen} />
        <main className="w-full">
          <Header open={sidebarOpen} setOpen={setSidebarOpen} />
          <div className="bg-[#f9f9f9] dark:bg-stone-900 rounded-3xl">
            <Toaster richColors />
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}